import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { VisibilityState } from "@tanstack/react-table";

interface TableStore {
  columnVisibility: Record<string, VisibilityState>;
  setColumnVisibility: (tableId: string, visibility: VisibilityState) => void;
  resetTableStore: () => void;
  columnOrder: Record<string, string[]>;
  setColumnOrder: (tableId: string, order: string[]) => void;
}

export const useTableStore = create<TableStore>()(
  persist(
    (set) => ({
      columnVisibility: {},
      columnOrder: {},
      setColumnVisibility: (tableId, visibility) =>
        set((state) => ({
          columnVisibility: {
            ...state.columnVisibility,
            [tableId]: visibility,
          },
        })),
        setColumnOrder: (tableId, order) =>
          set((state) => ({
            columnOrder: {
              ...state.columnOrder,
              [tableId]: order,
            },
          })),
      resetTableStore: () => set({ 
        columnVisibility: {},
        columnOrder: {},
       }),
    }),
    {
      name: "table-visibility-store",
      storage: createJSONStorage(() => window.localStorage),
    }
  )
);
